<script>
export default {
	created() {
		// Obtém a tradução
		const translatedText = this.$t('footer.legal.label');
		// Define o novo título da página
		document.title = translatedText + " | " + document.title.substring(document.title.indexOf("|") + 1);
	},
	data() {
		return {
			legal: ''
		}
	},
	async mounted() {
		this.legal = await ((await fetch(`mocks${import.meta.env.VITE_BASE_PATH}legal.html`)));
		this.legal = await this.legal.text()

	},
	beforeRouteEnter(to, from, next) {
		window.scrollTo(0, 0);
		next();
	}
}
</script>

<template>
	<section class="wrapper__terms" v-html="this.legal">

	</section>
</template>
